import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IndicatorService} from '@app/shared';
import {environment} from '@env/environment';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ISubscriptionStatus} from "@app/app/library/iModelSummary";
import {PDPService} from "@app/app/pdp/pdp/pdp.service";
import {AppParametersService} from "@app/core/token/app-parameters.service";
import {HttpService} from "@app/core";
import {NavigationBarService} from "@app/shared/navigation-bar/navigation-bar.service";
import {NavigationBarEnum} from "@app/shared/navigation-bar/navigation-bar.model";

@Component({
  selector: 'navaar-carousel-library',
  templateUrl: './carousel-library.component.html',
  styleUrls: ['./carousel-library.component.scss', '../context-menu-library/context-menu-library.component.scss'],
  animations: [
    trigger('slide', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(150)
      ]),
      transition(':leave',
        animate(150, style({opacity: 0})))
    ])
  ]
})
export class CarouselLibraryComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.isShowContextMenu) {
      this.isShowContextMenu = false;
    }
  }

  @Output() public onPaginate: EventEmitter<number> = new EventEmitter<number>();
  @Output() public OnCloseContextMenu: EventEmitter<void> = new EventEmitter<void>();
  @Output() public pageNoChange: EventEmitter<number> = new EventEmitter<number>();

  @Input()
  public get pageNo(): number {
    return this.pages;
  }

  public set pageNo(v: number) {
    this.pages = v;
  }

  @Input("is-direct-play") public isDirectPlay: boolean = false;
  @Input() public total: number = 0;
  @Input('page-size') public PAGE_SIZE = 20;
  @Input() public items: Array<any> = [];
  @Input() public isEnd: boolean = false;
  @Input('disable-when-fetch-data') public isLoading: boolean = false;
  @Input('tab') public tabNameContextMenu: 'bookmark' | 'library' | 'search';

  public isShowContextMenuOption: boolean = false;
  public isShowContextMenu: boolean = false;
  public subscriptionStatus: Partial<ISubscriptionStatus> | null = {};
  public identifierContextMenu: number;
  public audiobookIdContextMenu: string;
  public audiobookTitleContextMenu: string;
  public skip: number = 0;
  public pages: number = 0;
  public readonly BASE_HREF_IMAGE = environment.imageUrl;

  constructor(
    private readonly http: HttpService,
    private readonly navigationBarService: NavigationBarService,
    private readonly playService: PDPService,
    private readonly indicatorService: IndicatorService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly parameterService: AppParametersService,
    private readonly router: Router) {
  }

  ngOnInit(): void {
  }

  public navigate(identifier, title, item) {
    if (this.tabNameContextMenu === 'bookmark') {
      if (item.isOwner === false) {
        this.router.navigate(["/pdp", identifier], {
          relativeTo: this.activatedRoute,
        }).then(() => this.navigationBarService.activeMenu = NavigationBarEnum.vitrin);
        return;
      }
    }
    if (item?.subscriptionStatus != null ? (item.subscriptionStatus?.isSubscriptionConsumption && item.subscriptionStatus?.isExpired) : false) {
      this.parameterService.isShowMessageEndSubscription = true;
      return;
    }
    if (this.isDirectPlay) {
      this.indicatorService.showHude();
      this.playService.playWithIdentifierId(identifier, true).then(x => this.indicatorService.hideHude());
    } else
      this.router.navigate(["/pdp", identifier], {
        relativeTo: this.activatedRoute,
      }).then();
  }

  public onShowContextMenu(event: Event, item) {
    event.preventDefault();
    const {identifier, audiobookId, title, subscriptionStatus} = item;
    this.identifierContextMenu = identifier;
    this.audiobookIdContextMenu = audiobookId;
    this.audiobookTitleContextMenu = title;
    this.subscriptionStatus = subscriptionStatus;
    this.tabNameContextMenu = this.activatedRoute.snapshot.queryParams.type;
    this.isShowContextMenuOption = true;
  }

  public onRefreshData() {
    this.items = [];
    this.isLoading = true;
    this.indicatorService.showHude();
    this.skip = 0;
    this.onPaginate.emit(this.skip);
    this.onCloseContextMenu();
  }

  public onCloseContextMenu() {
    this.isShowContextMenuOption = false;
    this.identifierContextMenu =
      this.audiobookIdContextMenu =
        this.audiobookTitleContextMenu =
          this.subscriptionStatus = null;
    this.OnCloseContextMenu.emit();
  }
}
